<template>
    <div v-if="hasFieldToDisplay()" id="multimedia-section" style="margin-bottom: 30px">
        <div class="tabulation-title">
            <h5>
                <v-icon class="blue--text text--darken-2">label</v-icon>
                Vos multimédias
            </h5>
        </div>

        <div class="form-container mr-auto ml-auto mt-3" v-if="!hasMediaShown()">
            <v-alert type="error" text class="mt-5 mb-5 mr-auto ml-auto" border="right" colored-border>
                Nous n'avons aucune photo vous concernant.
            </v-alert>
        </div>

        <div class="form-container mr-auto ml-auto mt-3" v-if="hasMediaShown()">
            <v-alert type="info" text class="mt-5 mb-5 mr-auto ml-auto" border="right" colored-border>

                <div>
                    Il est obligatoire de renseigner le <b>copyright</b> avec vos photos. En l'absence de copyright nous
                    ne pourrons pas les diffuser.
                </div>

                <div>
                    <v-btn text color="primary" class="text-none" @click="infoCopyright = true">
                        Qu'est-ce qu'un copyright ?
                    </v-btn>
                </div>
            </v-alert>

            <div class="mt-5" v-if="provider.medias.length">
                <div class="tabulation-title mb-2">
                    <h5 class="d-flex">
                        <div class="mr-2">
                            <v-icon class="blue--text text--darken-2">label_outline</v-icon>
                            Image principale
                        </div>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on">help</v-icon>
                            </template>
                            <div>Si nous devions communiquer seulement une photo de votre activité, ce serait celle-ci
                            </div>
                        </v-tooltip>
                    </h5>
                </div>

                <div class="row m-0 medias-box">
                    <div class="col-6 col-lg-4 col-xl-3">
                        <v-card>
                            <a :href="formatMediaUrl(provider.medias[0])" target="_blank">
                                <v-img class="v-media"
                                       :src="(provider.medias[0].thumbnail_url !== null) ? provider.medias[0].thumbnail_url : provider.medias[0].url">
                                    <div class="media-logo"
                                         v-if="provider.medias[0].source !== undefined && provider.medias[0].source !== null && provider.medias[0].source.type !== 'APIDAE'">
                                        <img :src="'/images/logo-' + provider.medias[0].source.type + '.jpg'">
                                    </div>
                                </v-img>
                            </a>

                            <div class="clear-toolbar" v-if="!readOnly">
                                <v-icon size="26px" @click="deleteMedia(0)">
                                    clear
                                </v-icon>
                            </div>

                            <v-card-text>
                                <v-text-field label="Titre" v-model="provider.medias[0].name" outlined class="mb-3"
                                :disabled="readOnly">
                                </v-text-field>
                                <v-text-field
                                  :class="{ 'input-error': submitted &&
                                  (provider.medias[0].copyright === null || provider.medias[0].copyright === '') }"
                                  label="Copyright" v-model="provider.medias[0].copyright" outlined
                                  :disabled="readOnly">
                                </v-text-field>

                                <div class="w-100 text-center mt-2" v-if="!disabled && provider.medias.length > 1">
                                    <v-btn color="primary" @click="switchMediaModal = true" :disabled="readOnly">
                                        Changer
                                    </v-btn>
                                </div>
                            </v-card-text>
                        </v-card>
                    </div>
                </div>
            </div>

            <div class="mt-5">
                <div class="tabulation-title mb-2" v-if="provider.medias.length">
                    <h5>
                        <v-icon class="blue--text text--darken-2">label_outline</v-icon>
                        Autres images
                    </h5>
                </div>

                <div class="row m-0 medias-box">
                    <div class="col-6 col-lg-4 col-xl-3" v-for="(media, index) in provider.medias"
                         v-if="(media.is_404 === undefined || !media.is_404) && media.is_image && index !== 0">
                        <v-card>
                            <a :href="formatMediaUrl(media)" target="_blank">
                                <v-img class="v-media"
                                       :src="(media.thumbnail_url !== null) ? media.thumbnail_url : media.url">
                                    <div class="media-logo"
                                         v-if="media.source !== undefined && media.source !== null && media.source.type !== 'APIDAE'">
                                        <img :src="'/images/logo-' + media.source.type + '.jpg'">
                                    </div>
                                </v-img>
                            </a>

                            <div class="clear-toolbar" v-if="!readOnly">
                                <v-icon size="26px" @click="deleteMedia(index)">
                                    clear
                                </v-icon>
                            </div>

                            <v-card-text>
                                <v-text-field label="Titre" v-model="media.name" outlined class="mb-3"
                                              :disabled="readOnly">
                                </v-text-field>
                                <v-text-field
                                  :class="{ 'input-error': submitted && (media.copyright === null || media.copyright === '') }"
                                  label="Copyright" v-model="media.copyright" outlined :disabled="readOnly">
                                </v-text-field>
                            </v-card-text>
                        </v-card>
                    </div>

                    <!-- <div style="width: 250px" class="mb-5 mt-5 media-card">
                        <div ref="dashboardContainer"></div>
                        <div ref="dashboardProgress"></div>
                    </div> -->
                </div>

                <v-card style="box-shadow: 0 2px 5px 0 rgba(0,0,0,0.16),0 2px 10px 0 rgba(0,0,0,0.12) !important;"
                        class="mt-5"
                        v-if="sourcesLoaded && suggestedMedias.length > 0 || !sourcesLoaded">
                    <v-card-text>
                        <h2 style="font-size: 23px; font-family: 'Roboto',sans-serif; font-weight: 700" class="mb-3">
                            Ajouter d'autres photos depuis le web ?
                        </h2>

                        <div class="text-center" v-if="!sourcesLoaded">
                            <div>
                                Nous recherchons votre activité sur le web...
                            </div>
                            <v-progress-circular class="progressbar" indeterminate size="50" width="6">
                            </v-progress-circular>
                        </div>

                        <div v-if="suggestedMedias.length && sourcesLoaded">
                            <v-alert type="info" text class="mt-5 mb-5 mr-auto ml-auto" border="right" colored-border>
                                Vous avez ajouté les photos suivantes sur votre compte Google My Business.
                                Si vous en détenez les droits, vous pouvez les utiliser pour compléter ce formulaire,
                                en indiquant le copyright pour chaque photo afin qu'elles puissent être diffusées par
                                votre Office de Tourisme.
                            </v-alert>

                            <div class="d-flex flex-wrap mb-3 justify-start">
                                <v-hover v-slot="{ hover }" v-for="(media, index) in suggestedMedias">
                                    <v-img height="180px" class="m-2 v-media media-suggest" @click="showMedia(media)"
                                           style="box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)"
                                           :src="media.thumbnail_url !== undefined && media.thumbnail_url !== null ?
                                        media.thumbnail_url : media.origin_url">
                                        <div class="media-logo">
                                            <img :src="'/images/logo-' + media.source.type + '.jpg'">
                                        </div>

                                        <v-expand-transition>
                                            <div v-if="hover" class="transition-fast-in-fast-out darken-2 v-card--reveal
                                               display-3 white--text text-center" style="height: 60px; position: absolute; bottom: 0;
                                               width: 100%; background-color: rgba(0,0,0,0.4);">

                                                <v-btn color="primary" @click="addSuggstedMedia(index)" style="transform: translateY(-50%);
                                                      position: relative;top: 25%">Ajouter
                                                </v-btn>
                                            </div>
                                        </v-expand-transition>
                                    </v-img>
                                </v-hover>
                            </div>
                        </div>

                        <div v-if="!suggestedMedias.length && sourcesLoaded">
                            <v-alert type="info" text class="mt-5 mb-5 mr-auto ml-auto" border="right" colored-border>
                                Nous n'avons pas trouvé de photos concernant votre activité...
                                Vous pouvez nous déposer vos photos depuis l'espace réservé ci-dessus.
                            </v-alert>

                        </div>
                    </v-card-text>
                </v-card>
            </div>
        </div>

        <v-dialog v-model="showFullScreen" content-class="fullscreen-image" style="z-index: 2600">
            <div class="d-flex flex-column">
                <v-icon size="52px" class="white--text justify-end" @click="hideMedia"
                        style="position: absolute; right:0">clear
                </v-icon>
                <div @click="hideMedia">
                    <v-img v-if="selectedMedia !== null" contain
                           :src="(selectedMedia.url !== undefined && selectedMedia.url !== null) ? selectedMedia.url : selectedMedia.origin_url"
                           :lazy-src="selectedMedia.thumbnail_url" class="ml-auto" max-height="100vh" max-width="100vw">
                    </v-img>
                </div>
            </div>
        </v-dialog>

        <confirm ref="confirm" :hide-next="true"></confirm>

        <v-dialog v-model="infoCopyright" max-width="700px">
            <v-card>
                <v-card-title>
                    <h2 style="font-size: 20px !important;" class="headline-title">
                        À propos du droit d'auteur
                    </h2>
                </v-card-title>
                <v-card-text>
                    <h3 class="mt-2 headline-title" style="font-size: 14px">Qu'est-ce que le copyright ?</h3>

                    <div>
                        Le copyright est un libellé qui désigne l'identité du titulaire des droits de la photo
                        (personne physique ou personne morale). Il atteste que l'auteur est d'accord que vous diffusiez
                        ses photos.
                    </div>

                    <h3 class="mt-4 headline-title" style="font-size: 14px">Connaissez-vous l'auteur des photos ?</h3>

                    <div>
                        Si oui, et que celui-ci vous a octroyé les droits d'utilisation de la photo, alors vous pouvez
                        indiquer son nom en tant que copyright. Sinon il est préférable de ne pas diffuser la photo
                        (et de la retirer de ce formulaire).
                    </div>

                    <h3 class="mt-4 headline-title" style="font-size: 14px">Pourquoi est-ce important de saisir un
                        copyright ?</h3>

                    <div>
                        Sans copyright, l'auteur de la photo peut se retourner contre nous et réclamer des réparations
                        pour diffusion de la photo sans autorisation.
                        Pour éviter cette situation, nous ne diffusons pas de photos sans copyright.
                    </div>

                    <v-spacer></v-spacer>

                    <div class="text-center mt-5 w-100">
                        <v-btn class="text-none" color="success" outlined @click="infoCopyright = false">J'ai compris
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-snackbar v-model="displaySnackBar" bottom color="primary" :timeout="8000">
            <span>
                La photo a été ajoutée à votre réponse.
                Pour nous permettre de la diffuser, il est impératif d'indiquer son
                <b style="color:#a4ffa4;">copyright</b>.
            </span>
        </v-snackbar>

        <v-dialog v-model="switchMediaModal" max-width="1200px" @click-outside="switchMediaModal = false">
            <v-card>
                <v-card-title class="d-flex justify-content-between">
                    <h2 class="headline-title" style="font-size: 24px !important;">Modifier l'image principale</h2>

                    <v-btn color="error" @click="switchMediaModal = false">Fermer</v-btn>
                </v-card-title>

                <v-card-text>
                    <div class="d-flex justify-start medias-box flex-wrap">
                        <v-card v-for="(media, index) in provider.medias" class="m-3 media-card"
                                :class="{ 'selected-media': mediaToSelectFirst !== null && mediaToSelectFirst.url === media.url }"
                                v-if="(media.is_404 === undefined || !media.is_404) && media.is_image && index !== 0">
                            <v-img height="150px" width="250px" class="v-media"
                                   :src="(media.thumbnail_url !== null) ? media.thumbnail_url : media.url"
                                   @click="showMedia(media)">
                                <div class="media-logo"
                                     v-if="media.source !== undefined && media.source !== null && media.source.type !== 'APIDAE'">
                                    <img :src="'/images/logo-' + media.source.type + '.jpg'">
                                </div>
                            </v-img>

                            <v-card-text>
                                <div class="w-100 text-center mt-2">
                                    <v-btn color="primary" @click="swapMedias(media)">Sélectionner</v-btn>
                                </div>
                            </v-card-text>
                        </v-card>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex"
import Uppy from "@uppy/core"
import Dashboard from "@uppy/dashboard"
import ProgressBar from "@uppy/progress-bar"
import AwsS3 from "@uppy/aws-s3"
import Confirm from "../../tools/Confirm"
import French from "@uppy/locales/lib/fr_FR"
import "@uppy/core/dist/style.css"
import "@uppy/dashboard/dist/style.css"
import "@uppy/progress-bar/dist/style.css"

export default {
    name: "Medias",
    components: { Confirm },
    props: ['readOnly'],
    data() {
        return {
            selectedMedia: null,
            showFullScreen: false,
            uppy: null,
            addMod: false,
            displaySnackBar: false,
            infoCopyright: false,
            switchMediaModal: false,
            mediaToSelectFirst: null,
        }
    },
    methods: {
        ...mapMutations("web_form", ["removeMedia", "addMedia"]),
        hasFieldToDisplay() {
            return this.hasField("IMAGE")
        },
        showMedia(media) {
            if (!this.addMod) {
                this.selectedMedia = media
                this.showFullScreen = true
            }
        },
        hideMedia() {
            this.selectedMedia = null
            this.showFullScreen = false
        },
        deleteMedia(index) {
            if (!this.hideNextModal) {
                this.$refs.confirm.open("Attention",
                  "Êtes-vous sûr de vouloir supprimer cette photo ?",
                  { color: "red" }).then((confirm) => {
                    if (confirm) {
                        this.removeMedia(index)
                    }
                })
            } else {
                this.removeMedia(index)
            }
        },
        pushMedia(originUrl, thumbnailUrl, source = null, temp = true) {
            let media = {
                thumbnail_url: thumbnailUrl,
                name: null,
                copyright: null,
                temp: temp,
                origin_url: originUrl,
                source: source,
                is_image: true,
            }

            this.addMedia(media)
        },
        dec2hex(dec) {
            return dec < 10
              ? "0" + String(dec)
              : dec.toString(16)
        },
        generateId(len) {
            let arr = new Uint8Array((len || 40) / 2)
            window.crypto.getRandomValues(arr)
            return Array.from(arr, this.dec2hex).join("")
        },
        addSuggstedMedia(index) {
            this.addMod = true

            let media = this.suggestedMedias[index]

            this.pushMedia(media.origin_url, media.thumbnail_url, media.source, false)
            this.suggestedMedias.splice(index, 1)

            this.displaySnackBar = true

            setTimeout(() => {
                this.addMod = false
            }, 100)
        },
        hasMediaShown() {
            let medias = this.provider.medias.filter(media => !media.is_404)

            return medias !== undefined && medias !== null && medias.length > 0
        },
        swapMedias(mediaToSwap) {
            let indexToSwap = null

            this.provider.medias.forEach((media, index) => {
                if (media === mediaToSwap) {
                    indexToSwap = index
                }
            })

            let temp = JSON.parse(JSON.stringify(this.provider.medias[indexToSwap]))

            this.provider.medias[indexToSwap] = this.provider.medias[0]
            this.provider.medias[0] = temp

            this.switchMediaModal = false
        },
        formatMediaUrl(media) {
            let url = media.url

            if(media.url.includes('/thumbnails/')) {
                url = 'https://hubo-cmaj-prod.s3.eu-west-1.amazonaws.com/medias/'+ media.filename
            }

            return url
        }
    },
    computed: {
        ...mapState("web_form", ["provider", "hideNextModal", "disabled",
            "suggestedMedias", "sourcesLoaded", "submitted"]),
        ...mapState("webFormStyle", ["fontFamily", "primaryColor", "titlesColor", "fieldsColor", "backGroundColor"]),
        ...mapGetters("web_form", ["hasField", "hasFamilyElement", "getFamilyByCode", "getElementsByFamilyCode"]),
    },
    mounted() {
        if (!this.disabled && this.hasFieldToDisplay()) {
            let self = this

            this.uppy = Uppy({
                debug: true,
                autoProceed: true,
                locale: French,
                restrictions: {
                    maxFileSize: 9500000, // TODO: replace by 10485760
                    allowedFileTypes: ["image/png", "image/jpeg", "image/gif", "image/bmp"],
                },
            }).use(Dashboard, {
                hideUploadButton: true,
                inline: true,
                height: 287,
                width: "auto",
                target: this.$refs.dashboardContainer,
                replaceTargetContent: true,
                showProgressDetails: true,
                browserBackButtonClose: true,
                theme: "light",
                locale: {
                    strings: {
                        dropPaste: "Déposer les photos ici depuis votre %{browse}",
                        browse: "ordinateur ou smartphone",
                    },
                },
                proudlyDisplayPoweredByUppy: false,
                showSelectedFiles: false,
            }).use(ProgressBar, {
                target: this.$refs.dashboardProgress,
                hideAfterFinish: false,
            }).use(AwsS3, {
                companionUrl: process.env.VUE_APP_API_URL + "/api/companion",
                getUploadParameters(file) {
                    return fetch(process.env.VUE_APP_API_URL + "/api/companion", {
                        method: "post",
                        headers: {
                            accept: "application/json",
                            "content-type": "application/json",
                        },
                        body: JSON.stringify({
                            filename: self.generateId(20) + "." + file.extension,
                            contentType: file.type,
                            origin_filename: file.name,
                        }),
                    }).then((response) => {
                        return response.json()
                    }).then((data) => {
                        return {
                            method: data.method,
                            url: data.url,
                            fields: data.fields,
                            headers: data.headers,
                        }
                    })
                },
            })

            this.uppy.on("complete", (event) => {
                if (event.successful !== undefined) {
                    event.successful.forEach(result => {
                        let path = result.response.body.location
                        this.pushMedia(path, path)
                    })
                }

                this.uppy.reset()
            })
        }
    },
}
</script>